module.exports = __webpack_public_path__ + "static/casino2-26eaead8f9a04e8c8f8f063452162bfa.jpg";